<template>
  <div class="search-container">
    <div class="p-grid">
      <div class="p-col">
        <div class="p-input-icon-right search-input">
          <i
            class="pi pi-search"
            style="left: 0.5rem !important"
            v-if="!chips.length"
          />
          <i
            class="pi pi-angle-down"
            style="cursor: pointer"
            @click="$refs.searchFilters.toggle($event)"
          />
          <Chips
            type="text"
            style="width: 100%"
            :class="[
              {
                'search-input-placeholder-active': !chips.length,
              },
            ]"
            :placeholder="!chips.length ? 'Pesquisar' : ''"
            separator=","
            :modelValue="chips"
            @keyup.enter="search()"
            @add="addTerm($event)"
            @remove="removeChip($event)"
          />

          <div id="search-options" style="width: 100%"></div>

          <SearchContainer
            v-if="isMounted"
            ref="searchFilters"
            v-slot:default="{ isPanel }"
          >
            <div
              class="p-fluid search-options-fields"
              :style="
                optionsHeight && isPanel
                  ? { maxHeight: optionsHeight, paddingRight: '10px' }
                  : { maxHeight: '80vh' }
              "
            >
              <div class="p-field p-grid">
                <label
                  class="p-col-4"
                  v-tooltip.top="'Pesquisar bovinos pelos seus brincos.'"
                >
                  <span class="material-icons search-option-icon p-mr-3"
                    >local_offer</span
                  >
                  Brincos
                </label>
                <div
                  class="p-col-8"
                  v-tooltip.top="
                    'Informar vários brincos separados por vírgula.'
                  "
                >
                  <InputText v-model="searchFilters.earring.value" />
                </div>
              </div>
              <div class="p-field p-grid">
                <label
                  class="p-col-4"
                  v-tooltip.top="
                    'Pesquisar bovinos que não possuem os brincos informados.'
                  "
                >
                  <span class="material-icons search-option-icon p-mr-3"
                    >local_offer</span
                  >
                  Bovinos exceto
                </label>
                <div
                  class="p-col-8"
                  v-tooltip.top="
                    'Informar vários brincos separados por vírgula.'
                  "
                >
                  <InputText v-model="searchFilters.excludeEarring.value" />
                </div>
              </div>
              <div class="p-field p-grid">
                <label class="p-col-4">
                  <span class="search-option-icon p-mr-3">
                    <IconBovineType
                      :width="20"
                      :height="20"
                      style="padding-top: 5px"
                    />
                  </span>
                  Tipos
                </label>
                <div class="p-col-8">
                  <MultiSelect
                    @click="fetchOptions('types')"
                    v-model="searchFilters.types.value"
                    :options="searchFilters.types.options"
                    optionLabel="name"
                    emptyFilterMessage="Nenhum resultado"
                    appendTo="body"
                    filter
                  >
                  </MultiSelect>
                </div>
              </div>
              <div class="p-field p-grid">
                <label class="p-col-4">
                  <span class="search-option-icon p-mr-3">
                    <IconBreed :width="16" :height="14" />
                  </span>
                  Raças
                </label>
                <div class="p-col-8">
                  <MultiSelect
                    @click="fetchOptions('breeds')"
                    v-model="searchFilters.breeds.value"
                    :options="searchFilters.breeds.options"
                    optionLabel="name"
                    emptyFilterMessage="Nenhum resultado"
                    appendTo="body"
                    filter
                  >
                  </MultiSelect>
                </div>
              </div>
              <div class="p-field p-grid">
                <label class="p-col-4">
                  <span class="search-option-icon p-mr-3">
                    <IconWeight
                      style="margin-top: 5px"
                      :width="18"
                      :height="15"
                    ></IconWeight>
                  </span>
                  Peso entre
                </label>
                <div class="p-col-4">
                  <InputNumber
                    v-model="searchFilters.weight.value[0]"
                    mode="decimal"
                    :minFractionDigits="2"
                  />
                </div>
                <div class="p-col-4">
                  <InputNumber
                    v-model="searchFilters.weight.value[1]"
                    mode="decimal"
                    :minFractionDigits="2"
                  />
                </div>
              </div>
              <div class="p-field p-grid">
                <label class="p-col-12 p-md-4">
                  <span class="material-icons search-option-icon p-mr-3">
                    event
                  </span>
                  Nascimento entre
                </label>
                <div class="p-col-12 p-md-4">
                  <Calendar
                    v-model="searchFilters.birthDate.value[0]"
                    dateFormat="dd/mm/yy"
                    showIcon
                    :monthNavigator="true"
                    :yearNavigator="true"
                    :yearRange="birthDateRange"
                    :locale="$locales.calendar.ptBR"
                    :showOnFocus="false"
                    v-mask="'##/##/####'"
                    appendTo="body"
                  />
                </div>
                <div class="p-col-12 p-md-4">
                  <Calendar
                    v-model="searchFilters.birthDate.value[1]"
                    dateFormat="dd/mm/yy"
                    showIcon
                    :monthNavigator="true"
                    :yearNavigator="true"
                    :yearRange="birthDateRange"
                    :locale="$locales.calendar.ptBR"
                    :showOnFocus="false"
                    v-mask="'##/##/####'"
                    appendTo="body"
                  />
                </div>
              </div>
              <div class="p-field p-grid">
                <label class="p-col-12 p-md-4">
                  <span class="material-icons search-option-icon p-mr-3">
                    event
                  </span>
                  Previsão de parto
                </label>
                <div class="p-col-12 p-md-4">
                  <Calendar
                    v-model="searchFilters.childBirth.value[0]"
                    dateFormat="dd/mm/yy"
                    showIcon
                    :monthNavigator="true"
                    :yearNavigator="true"
                    :yearRange="birthDateRange"
                    :locale="$locales.calendar.ptBR"
                    :showOnFocus="false"
                    v-mask="'##/##/####'"
                    appendTo="body"
                  />
                </div>
                <div class="p-col-12 p-md-4">
                  <Calendar
                    v-model="searchFilters.childBirth.value[1]"
                    dateFormat="dd/mm/yy"
                    showIcon
                    :monthNavigator="true"
                    :yearNavigator="true"
                    :yearRange="birthDateRange"
                    :locale="$locales.calendar.ptBR"
                    :showOnFocus="false"
                    v-mask="'##/##/####'"
                    appendTo="body"
                  />
                </div>
              </div>
              <div class="p-field p-grid">
                <label class="p-col-12 p-md-4">
                  <span class="material-icons search-option-icon p-mr-3">
                    hourglass_empty
                  </span>
                  Idade entre
                </label>
                <div class="p-col-12 p-md-2">
                  <InputNumber
                    v-model="searchFilters.age.value[0]"
                    mode="decimal"
                    :minFractionDigits="1"
                  />
                </div>
                <div class="p-col-12 p-md-2">
                  <InputNumber
                    v-model="searchFilters.age.value[1]"
                    mode="decimal"
                    :minFractionDigits="1"
                  />
                </div>
                <div class="p-col">
                  <Dropdown
                    v-model="searchFilters.age.value[2]"
                    :options="searchFilters.age.options"
                    optionLabel="name"
                    optionValue="value"
                    appendTo="body"
                    style="width: 100%"
                  />
                </div>
              </div>
              <div class="p-field p-grid">
                <label class="p-col-12 p-md-4">
                  <span class="material-icons search-option-icon p-mr-3">
                    hourglass_empty
                  </span>
                  Data do parto
                </label>
                <div class="p-col-12 p-md-2">
                  <InputNumber
                    v-model="searchFilters.lastChildBirth.value[0]"
                    mode="decimal"
                    :minFractionDigits="1"
                  />
                </div>
                <div class="p-col-12 p-md-2">
                  <InputNumber
                    v-model="searchFilters.lastChildBirth.value[1]"
                    mode="decimal"
                    :minFractionDigits="1"
                  />
                </div>
                <div class="p-col">
                  <Dropdown
                    v-model="searchFilters.lastChildBirth.value[2]"
                    :options="searchFilters.lastChildBirth.options"
                    optionLabel="name"
                    optionValue="value"
                    appendTo="body"
                    style="width: 100%"
                  />
                </div>
              </div>
              <div class="p-field p-grid">
                <label class="p-col-4">
                  <span class="material-icons search-option-icon p-mr-3"
                    >info</span
                  >
                  Status
                </label>
                <div class="p-col-8">
                  <MultiSelect
                    @click="fetchOptions('status')"
                    v-model="searchFilters.status.value"
                    :options="searchFilters.status.options"
                    optionLabel="name"
                    emptyFilterMessage="Nenhum resultado"
                    appendTo="body"
                    filter
                  >
                  </MultiSelect>
                </div>
              </div>
              <div class="p-field p-grid">
                <label class="p-col-4">
                  <span class="material-icons search-option-icon p-mr-3"
                    >map</span
                  >
                  Fazenda
                </label>
                <div class="p-col-8">
                  <MultiSelect
                    @click="fetchOptions('farms')"
                    @change="resetFarmLotFilters()"
                    v-model="searchFilters.farms.value"
                    :options="searchFilters.farms.options"
                    optionLabel="name"
                    emptyFilterMessage="Nenhum resultado"
                    appendTo="body"
                    scrollHeight="120px"
                    filter
                  >
                  </MultiSelect>
                </div>
              </div>
              <div class="p-field p-grid">
                <label class="p-col-4">
                  <span class="material-icons search-option-icon p-mr-3"
                    >place</span
                  >
                  Lotes / Piquetes
                </label>
                <div class="p-col-8">
                  <MultiSelect
                    @click="onFilterOptions('farmLots', {})"
                    @filter="onFilterOptions('farmLots', $event)"
                    v-model="searchFilters.farmLots.value"
                    :options="searchFilters.farmLots.options"
                    optionLabel="name"
                    emptyFilterMessage="Nenhum resultado"
                    appendTo="body"
                    scrollHeight="100px"
                    filter
                  >
                  </MultiSelect>
                </div>
              </div>
              <div class="p-field p-grid">
                <label class="p-col-12 p-md-4">
                  <span class="material-icons search-option-icon p-mr-3"
                    >person</span
                  >
                  Proprietários</label
                >
                <div class="p-col-12 p-md-8">
                  <MultiSelect
                    @click="fetchOptions('owners')"
                    v-model="searchFilters.owners.value"
                    :options="searchFilters.owners.options"
                    optionLabel="name"
                    emptyFilterMessage="Nenhum resultado"
                    appendTo="body"
                    scrollHeight="100px"
                    filter
                  >
                  </MultiSelect>
                </div>
              </div>
              <div class="p-field p-grid">
                <label class="p-col-4">
                  <span class="search-option-icon p-mr-3"
                    ><IconService :width="17" :height="17"
                  /></span>
                  Serviços
                </label>
                <div class="p-col-8">
                  <MultiSelect
                    @click="fetchOptions('service')"
                    v-model="searchFilters.service.value"
                    :options="searchFilters.service.options"
                    optionLabel="name"
                    emptyFilterMessage="Nenhum resultado"
                    appendTo="body"
                    filter
                  >
                    <template #option="props">
                      <span class="p-mr-2">{{ props.option.id }} -</span>
                      <span class="p-mr-2">
                        <ServiceType
                          :value="props.option.type.path"
                          :background="props.option.type.color"
                        ></ServiceType>
                      </span>
                      <span v-if="props.option.dateStart">
                        -
                        {{ $formatDate(props.option.dateStart) }}
                      </span>
                    </template>
                  </MultiSelect>
                </div>
              </div>
              <div class="p-field p-grid">
                <label
                  class="p-col-4"
                  v-tooltip.top="'Pesquisar crias pelo brinco de sua Matriz.'"
                >
                  <span class="search-option-icon p-mr-3"
                    ><IconRoot :width="16" :height="16"
                  /></span>
                  Brinco da Matriz
                </label>
                <div
                  class="p-col-8"
                  v-tooltip.top="
                    'Informar vários brincos separados por vírgula.'
                  "
                >
                  <InputText v-model="searchFilters.rootEarring.value" />
                </div>
              </div>
              <div class="p-field p-grid">
                <label class="p-col-4">
                  <span class="search-option-icon p-mr-3"
                    ><IconBull :width="16" :height="16"
                  /></span>
                  Touro
                </label>
                <div class="p-col-8">
                  <MultiSelect
                    @click="fetchOptions('bullType')"
                    v-model="searchFilters.bullType.value"
                    :options="searchFilters.bullType.options"
                    optionLabel="name"
                    emptyFilterMessage="Nenhum resultado"
                    appendTo="body"
                    filter
                  >
                  </MultiSelect>
                </div>
              </div>
              <div class="p-field p-grid">
                <label
                  class="p-col-4"
                  v-tooltip.top="'Pesquisar somente Vacas que possuem crias.'"
                >
                  <span class="search-option-icon p-mr-3"
                    ><IconRoot :width="16" :height="16"
                  /></span>
                  Vaca Matriz</label
                >
                <div class="p-col-8">
                  <Dropdown
                    v-model="searchFilters.isRoot.value"
                    :options="searchFilters.isRoot.options"
                    optionLabel="name"
                    appendTo="body"
                    style="width: 100%"
                  />
                </div>
              </div>
              <div class="p-field p-grid">
                <label
                  class="p-col-4"
                  v-tooltip.top="
                    'Pesquisar as vacas e as suas crias em sequência'
                  "
                >
                  <span class="search-option-icon p-mr-3"
                    ><IconRoot :width="16" :height="16"
                  /></span>
                  Agrupar Matriz e crias</label
                >
                <div class="p-col-8">
                  <Dropdown
                    v-model="searchFilters.groupRootAndChild.value"
                    :options="searchFilters.groupRootAndChild.options"
                    optionLabel="name"
                    appendTo="body"
                    style="width: 100%"
                  />
                </div>
              </div>
              <div class="p-field p-grid">
                <label class="p-col-12 p-md-4">
                  <span class="material-icons search-option-icon p-mr-3">
                    event
                  </span>
                  Cadastro entre
                </label>
                <div class="p-col-12 p-md-4">
                  <Calendar
                    v-model="searchFilters.createdAt.value[0]"
                    dateFormat="dd/mm/yy"
                    showIcon
                    :monthNavigator="true"
                    :yearNavigator="true"
                    :yearRange="birthDateRange"
                    :locale="$locales.calendar.ptBR"
                    :showOnFocus="false"
                    v-mask="'##/##/####'"
                    appendTo="body"
                  />
                </div>
                <div class="p-col-12 p-md-4">
                  <Calendar
                    v-model="searchFilters.createdAt.value[1]"
                    dateFormat="dd/mm/yy"
                    showIcon
                    :monthNavigator="true"
                    :yearNavigator="true"
                    :yearRange="birthDateRange"
                    :locale="$locales.calendar.ptBR"
                    :showOnFocus="false"
                    v-mask="'##/##/####'"
                    appendTo="body"
                  />
                </div>
              </div>
              <div class="p-field p-grid">
                <label class="p-col-12 p-md-4">
                  <span class="material-icons search-option-icon p-mr-3">
                    event
                  </span>
                  Editado entre
                </label>
                <div class="p-col-12 p-md-4">
                  <Calendar
                    v-model="searchFilters.updatedAt.value[0]"
                    dateFormat="dd/mm/yy"
                    showIcon
                    :monthNavigator="true"
                    :yearNavigator="true"
                    :yearRange="birthDateRange"
                    :locale="$locales.calendar.ptBR"
                    :showOnFocus="false"
                    v-mask="'##/##/####'"
                    appendTo="body"
                  />
                </div>
                <div class="p-col-12 p-md-4">
                  <Calendar
                    v-model="searchFilters.updatedAt.value[1]"
                    dateFormat="dd/mm/yy"
                    showIcon
                    :monthNavigator="true"
                    :yearNavigator="true"
                    :yearRange="birthDateRange"
                    :locale="$locales.calendar.ptBR"
                    :showOnFocus="false"
                    v-mask="'##/##/####'"
                    appendTo="body"
                  />
                </div>
              </div>
            </div>
            <div class="p-fluid" style="margin-top: 20px">
              <div class="p-grid p-jc-end">
                <div class="p-col-4">
                  <Button label="Pesquisar" @click="search()" />
                </div>
              </div>
            </div>
          </SearchContainer>
        </div>
      </div>
      <div class="p-col-3">
        <Dropdown
          v-model="searchOrder.orderField"
          :options="searchOrder.options"
          optionLabel="name"
          placeholder="Ordenar por"
          @change="search()"
          style="width: 100%"
        />
      </div>
      <div class="p-col-fixed search-order" style="width: 50px">
        <Button
          :icon="orderIcon"
          class="p-button-text p-button-plain"
          @click="changeOrder()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'debounce';
import IconBreed from '../../../components/icon/IconBreed.vue';
import IconWeight from '../../../components/icon/IconWeight.vue';
import IconRoot from '../../../components/icon/IconRoot.vue';
import IconBull from '../../../components/icon/IconBull.vue';
import IconBovineType from '../../../components/icon/IconBovineType.vue';
import ServiceType from '../../Service/components/ServiceType.vue';
import IconService from '../../../components/icon/IconService.vue';
import {
  useTermFilter,
  useEarringFilter,
  useExcludeEarringFilter,
  useTypeFilter,
  useBreedFilter,
  useWeightFilter,
  useBirthDateFilter,
  useAgeFilter,
  useStatusFilter,
  useFarmFilter,
  useFarmLotFilter,
  useOwnerFilter,
  useRootEarringFilter,
  useIsRootFilter,
  useGroupRootAndChildFilter,
  useCreatedAtFilter,
  useUpdatedAtFilter,
  useLastChildBirthFilter,
  useServiceFilter,
} from '../../../lib/bovineSearch';
import { useDateRangeFilter, useIdsFilter } from '../../../lib/search';
import { BullApi } from '../../../services/api';
import SearchContainer from '../../../components/SearchContainer.vue';

export default {
  name: 'BovineSearch',
  components: {
    IconBreed,
    IconWeight,
    IconRoot,
    IconBovineType,
    IconBull,
    IconService,
    ServiceType,
    SearchContainer,
  },
  props: {
    optionsHeight: {
      type: [Number, String],
      default: () => '70vh',
    },
    defaultQuery: {
      type: Object,
      deafult: () => ({}),
    },
    apiOptions: Object,
    cache: Boolean,
    cacheKey: String,
  },
  data() {
    return {
      birthDateRange: `${this.$dayjs()
        .subtract(10, 'y')
        .format('YYYY')}:${this.$dayjs().add(10, 'y').format('YYYY')}`,
      chips: [],
      searchFilters: {
        term: useTermFilter(),
        earring: useEarringFilter(),
        excludeEarring: useExcludeEarringFilter(),
        types: useTypeFilter(),
        breeds: useBreedFilter(),
        weight: useWeightFilter(),
        birthDate: useBirthDateFilter(),
        childBirth: useDateRangeFilter('Previsão de Parto', 'childBirth'),
        bullType: useIdsFilter('Touro', 'bullTypeId', 'name', BullApi.fetch),
        age: useAgeFilter(),
        lastChildBirth: useLastChildBirthFilter(),
        status: useStatusFilter(),
        farms: useFarmFilter(),
        farmLots: useFarmLotFilter(),
        owners: useOwnerFilter(),
        rootEarring: useRootEarringFilter(),
        isRoot: useIsRootFilter(),
        groupRootAndChild: useGroupRootAndChildFilter(),
        createdAt: useCreatedAtFilter(),
        updatedAt: useUpdatedAtFilter(),
        service: useServiceFilter(),
      },
      searchOrder: {
        orderField: null,
        order: '',
        options: [
          { name: 'Lançamento', value: 'id' },
          { name: 'Brinco', value: 'earring' },
          { name: 'Tipo', value: 'type.name' },
          { name: 'Raça', value: 'breed.name' },
          { name: 'Peso', value: 'weight' },
          { name: 'Data de Nascimento', value: 'birthDate' },
          { name: 'Idade', value: 'age' },
          { name: 'Status', value: 'status.name' },
          { name: 'Matriz', value: 'bovineRoot.earring' },
          { name: 'Proprietário', value: 'owner.name' },
          { name: 'Fazenda', value: 'farm.name' },
          { name: 'Lote/Piquete', value: 'farmLot.name' },
          { name: 'Previsão de Parto', value: 'childBirth' },
          { name: 'Touro', value: 'bullType.name' },
        ],
      },
      isMounted: false,
    };
  },
  async created() {
    const farmId = this.defaultQuery?.farmId || this.$route.query.farmId;
    if (farmId) {
      await this.setFilterByOption('farms', farmId);
    }
    if (this.$route.query.lotId) {
      await this.setFilterByOption('farmLots', this.$route.query.lotId);
    }
    if (this.$route.query.ownerId) {
      await this.setFilterByOption('owners', this.$route.query.ownerId);
    }
    if (this.$route.query.serviceId) {
      await this.setFilterByOption('service', this.$route.query.serviceId, {
        id: this.$route.query.serviceId,
      });
    }
    if (this.cache) {
      this.loadCache();
    } else {
      const { chips } = this.buildQuery();
      this.chips = chips;
    }
  },
  mounted() {
    this.isMounted = true;
  },
  computed: {
    orderIcon() {
      if (!this.searchOrder.order) {
        return 'pi pi-sort-alt';
      }
      return this.searchOrder.order === 'asc'
        ? 'pi pi-sort-amount-up'
        : 'pi pi-sort-amount-down';
    },
  },
  methods: {
    loadCache() {
      const cacheData = this.cacheKey && localStorage.getItem(this.cacheKey);
      if (cacheData) {
        const cachedFilters = JSON.parse(cacheData);
        Object.keys(cachedFilters).forEach((key) => {
          this.searchFilters[key].value = cachedFilters[key].value;
          this.searchFilters[key].options = cachedFilters[key].options;
        });
      }
      this.$nextTick(() => {
        this.search();
      });
    },
    async setFilterByOption(field, value, query) {
      await this.fetchOptions(field, query);
      this.searchFilters[field].value = this.searchFilters[
        field
      ].options.filter((option) => option.id === Number(value));
    },
    addTerm({ value }) {
      const term = value
        .filter((v) => !v.includes(':') || v.includes('Termo: '))
        .map((v) => v.replace('Termo:', '').trim());
      this.searchFilters.term.value = term;
      this.search();
    },
    removeChip(event) {
      const [name, value] = event.value[0].split(': ');
      const field = Object.keys(this.searchFilters).find(
        (key) => this.searchFilters?.[key]?.name === name
      );
      const searchFilter = this.searchFilters[field];
      if (searchFilter.removeValue) {
        this.searchFilters[field].value = searchFilter.removeValue(
          searchFilter.value,
          value
        );
      }
      this.search();
    },
    changeOrder() {
      this.searchOrder.order =
        this.searchOrder.order === 'asc' ? 'desc' : 'asc';
      this.search();
    },
    async fetchOptions(field, query = {}) {
      const option = this.searchFilters[field];
      if (option && option.fetchOptions && !option.options.length) {
        option.options = await option.fetchOptions(
          query,
          this.searchFilters,
          this.apiOptions
        );
      }
    },
    onFilterOptions: debounce(async function onFilterOptions(field, { value }) {
      const option = this.searchFilters[field];
      if (option && option.fetchOptions) {
        option.options = await option.fetchOptions(
          { value },
          this.searchFilters,
          this.apiOptions
        );
      }
    }, 300),
    resetFarmLotFilters() {
      this.searchFilters.farmLots.value = [];
      this.searchFilters.farmLots.options = [];
    },
    buildQuery() {
      const query = {};
      const chips = [];

      Object.keys(this.searchFilters).forEach((key) => {
        const option = this.searchFilters[key];
        if (
          (Array.isArray(option.value) && !option.value.length) ||
          (!Array.isArray(option.value) && !option.value)
        ) {
          return;
        }
        if (option.query) {
          Object.assign(query, option.query(option.value));
        }
        if (option.chips) {
          chips.push(...option.chips(option.name, option.value));
        }
      });

      if (this.searchOrder?.orderField?.value) {
        query.orderField = this.searchOrder?.orderField?.value;
        if (
          !this.searchOrder?.order &&
          this.searchOrder?.orderField?.value === 'owner.name'
        ) {
          this.searchOrder.order = 'asc';
        }
      }
      if (this.searchOrder?.order) {
        query.order = this.searchOrder?.order;
      }
      return { query, chips };
    },
    search: debounce(
      function search() {
        const { query, chips } = this.buildQuery();
        this.chips = chips;
        this.$emit('search', { query });
        if (this.$refs.searchFilters) {
          this.$refs.searchFilters.hide();
        }
      },
      250,
      true
    ),
  },
  beforeUnmount() {
    if (this.cache && this.cacheKey) {
      localStorage.setItem(this.cacheKey, JSON.stringify(this.searchFilters));
    }
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  ::v-deep .p-overlaypanel {
    left: 0 !important;
  }
  ::v-deep .p-overlaypanel:after,
  .p-overlaypanel:before {
    left: calc(var(--overlayArrowLeft, 0) + 0.6rem);
  }
  ::v-deep .p-overlaypanel:before {
    left: calc(var(--overlayArrowLeft, 0) + 0.6rem);
  }
}

.p-col-12 {
  margin-bottom: 5px;
}

.search-option-icon {
  font-size: 18px;
  color: #495057;
}

.search-options-fields {
  overflow-y: auto;
  overflow-x: hidden;
}

.search-input {
  width: 100%;

  ::v-deep .p-chips-multiple-container {
    width: 100%;
    display: inline;
  }

  // ::v-deep .p-chips-token {
  //   margin-bottom: 4px;
  // }
}

.search-input-placeholder-active {
  ::v-deep input {
    padding-left: 1.5rem !important;
  }
}

.search-order {
  button {
    background-color: white;
  }
}

.search-order .p-button {
  border: 1px solid #ced4da !important;
  border-radius: 3px !important;
}

@media (max-width: 600px) {
  .search-container .p-col {
    flex-grow: unset !important;
    flex-basis: unset !important;
    width: 100%;
  }
  .search-container .p-col-3 {
    flex-grow: 1;
    flex-basis: 0;
  }
  .search-order {
    width: 47px !important;
  }
}
</style>
